<template>
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="#EB5AA9">
        <path d="M9.99996 1.6665C5.39996 1.6665 1.66663 5.39984 1.66663 9.99984C1.66663 14.5998 5.39996 18.3332 9.99996 18.3332C14.6 18.3332 18.3333 14.5998 18.3333 9.99984C18.3333 5.39984 14.6 1.6665 9.99996 1.6665ZM9.16663 13.3332H7.49996V6.6665H9.16663V13.3332ZM12.5 13.3332H10.8333V6.6665H12.5V13.3332Z" fill="inherit"/>
    </svg>
</template>
